import PaymentSvc from '@/common/service/modules/PaymentSvc';

export default {
  async fetchPaymentList({ commit }, params) {
    const response = await PaymentSvc.getPaymentList(params);
    const { code, entity } = response;
    if (code === 1) {
      commit('setPaymentList', entity);
    }
  },

  async fetchPaymentDetail({ commit }, studentOrderNo) {
    const response = await PaymentSvc.getPaymentDetail(studentOrderNo);
    const { code, entity } = response;
    if (code === 1) {
      commit('setPaymentInfo', entity);
    }
  }
};
